import React, { useCallback, useMemo } from 'react'
import { useGoogleWebfontsList } from '../googleWebfontHelper/use_google_webfonts_list'

export const SuggestedFonts = ({ selectFont }: { selectFont: (font: string) => void }) => {
  return (
    <>
      <div className="mb-4">
        <span>
          {i18n.t('fundraising_events.manage.live_widgets.configurator.font_family.suggested_fonts.for_example')}
        </span>{' '}
        <CommaSeparatedSuggestedFontList selectFont={selectFont} />{' '}
        <span>{i18n.t('fundraising_events.manage.live_widgets.configurator.font_family.suggested_fonts.or')}</span>{' '}
        <a href="https://fonts.google.com/" target="_blank" rel="noreferrer">
          {i18n.t('fundraising_events.manage.live_widgets.configurator.font_family.suggested_fonts.link_text')}
        </a>
        <span>.</span>
      </div>
    </>
  )
}

const CommaSeparatedSuggestedFontList = ({ selectFont }: { selectFont: (font: string) => void }) => {
  const googleWebfontsList = useGoogleWebfontsList()
  const googleWebfontsSelection = useMemo(() => googleWebfontsList.slice(0, 9), [googleWebfontsList])

  return (
    <>
      {googleWebfontsSelection.map((font, index) => (
        <FontListItem
          key={font.family}
          fontFamily={font.family}
          selectFont={selectFont}
          seperator={index ? ', ' : ''}
        />
      ))}
    </>
  )
}

const FontListItem = ({
  fontFamily,
  selectFont,
  seperator,
}: {
  fontFamily: string
  selectFont: (font: string) => void
  seperator: string
}) => {
  const handleClick = useCallback(() => selectFont(fontFamily), [selectFont, fontFamily])

  return (
    <>
      {seperator}
      <button type="button" className="gentle-link" onClick={handleClick}>
        {fontFamily}
      </button>
    </>
  )
}
